import { render } from "./NoteDialog.vue?vue&type=template&id=7d1e2022&scoped=true&ts=true"
import script from "./NoteDialog.vue?vue&type=script&lang=ts"
export * from "./NoteDialog.vue?vue&type=script&lang=ts"

import "./NoteDialog.vue?vue&type=style&index=0&id=7d1e2022&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1e2022"]])

export default __exports__